var m = Object.defineProperty;
var a = Object.getOwnPropertySymbols;
var n = Object.prototype.hasOwnProperty, s = Object.prototype.propertyIsEnumerable;
var o = (e, t, c) => t in e ? m(e, t, { enumerable: !0, configurable: !0, writable: !0, value: c }) : e[t] = c, h = (e, t) => {
  for (var c in t || (t = {}))
    n.call(t, c) && o(e, c, t[c]);
  if (a)
    for (var c of a(t))
      s.call(t, c) && o(e, c, t[c]);
  return e;
};
var i = (e, t) => {
  var c = {};
  for (var l in e)
    n.call(e, l) && t.indexOf(l) < 0 && (c[l] = e[l]);
  if (e != null && a)
    for (var l of a(e))
      t.indexOf(l) < 0 && s.call(e, l) && (c[l] = e[l]);
  return c;
};
import * as r from "react";
const g = (l) => {
  var v = l, {
    title: e,
    titleId: t
  } = v, c = i(v, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ r.createElement("svg", h({ xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, viewBox: "0 0 32 32", fill: "currentColor", "aria-labelledby": t }, c), e ? /* @__PURE__ */ r.createElement("title", { id: t }, e) : null, /* @__PURE__ */ r.createElement("path", { d: "M14.66665625 9.33334375h2.66665625v2.66665625h-2.66665625v-2.66665625zM16 2.66665625c-7.33334375 0-13.33334375 6-13.33334375 13.33334375s6 13.33334375 13.33334375 13.33334375 13.33334375-6 13.33334375-13.33334375-6-13.33334375-13.33334375-13.33334375zM16 26.66665625c-5.86665625 0-10.66665625-4.8-10.66665625-10.66665625s4.8-10.66665625 10.66665625-10.66665625 10.66665625 4.8 10.66665625 10.66665625-4.8 10.66665625-10.66665625 10.66665625zM16 22.66665625v0c-0.8 0-1.33334375-0.66665625-1.33334375-1.33334375v-5.33334375c0-0.8 0.53334375-1.33334375 1.33334375-1.33334375v0c0.8 0 1.33334375 0.53334375 1.33334375 1.33334375v5.33334375c0 0.66665625-0.53334375 1.33334375-1.33334375 1.33334375z" }));
};
export {
  g as default
};
